export default __webpack_public_path__ + "static/contactusBg-f0a57084f5fe4f82370f727eeeae5b68.svg";